function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Text } from '@fluentui/react';
import { SafeHtmlWrapper } from '@shared/components';
import { Constants } from '@shared/utils/constants';
import { getBillingTermTranslated } from '@shared/utils/pricing';
import { SaasPlanNameCell } from '../saasPlanNameCell';
import { SaasPricingCell } from '../saasPricingCell';
import { SaasSubtotalCell } from '../saasSubtotalCell';
const planNameWidthsByNumberOfTags = [
    {
        // 0 Tags
        minWidth: 176,
        maxWidth: 422
    },
    {
        // 1 Tag
        minWidth: 284,
        maxWidth: 530
    },
    {
        // 2 Tags
        minWidth: 366,
        maxWidth: 612
    }
];
const baseColumn = {
    styles: {
        cellTitle: {
            paddingLeft: 16
        },
        root: {
            height: 'fit-content'
        }
    }
};
const getPlanNameColumn = (context, skus, onGetInNowClicked)=>{
    const hasPrivatePlans = skus.some((sku)=>sku.isPrivate);
    const hasFreeTrial = skus.some((sku)=>sku.freeTrialDurationDays);
    const planNameWidths = planNameWidthsByNumberOfTags[Number(hasPrivatePlans) + Number(hasFreeTrial)];
    return _object_spread_props(_object_spread({}, baseColumn), {
        key: 'plan-name',
        name: context.loc('SimplePlanPricing_ColumnHeader_Plan', 'Plan'),
        minWidth: planNameWidths.minWidth,
        maxWidth: planNameWidths.maxWidth,
        onRender: ({ sku })=>/*#__PURE__*/ _jsx(SaasPlanNameCell, {
                sku: sku,
                offerHasFreeTrialPlans: skus.some((sku)=>sku.freeTrialDurationDays),
                offerHasPrivatePlans: skus.some((sku)=>sku.isPrivate),
                onGetInNowClicked: ()=>onGetInNowClicked(sku.id)
            })
    });
};
const getDescriptionColumn = (context)=>_object_spread_props(_object_spread({}, baseColumn), {
        key: 'description',
        name: context.loc('SimplePlanPricing_ColumnHeader_Description', 'Description'),
        minWidth: 320,
        maxWidth: 696,
        onRender: ({ sku })=>/*#__PURE__*/ _jsx(SafeHtmlWrapper, {
                className: "plan-description-wrapper",
                html: sku.description
            })
    });
const getPriceAndPaymentOptionsColumn = (context, billingCountry, shouldBlockPrices, locale)=>_object_spread_props(_object_spread({}, baseColumn), {
        key: 'price-and-payment',
        name: context.loc('SimplePlanPricing_ColumnHeader_PriceAndPaymentOptions', 'Price/payment options'),
        minWidth: 206,
        isMultiline: true,
        onRender: ({ price, sku, futurePriceSku })=>/*#__PURE__*/ _jsx(SaasPricingCell, {
                price: price,
                sku: sku,
                futurePriceSku: futurePriceSku,
                billingCountry: billingCountry,
                shouldBlockPrices: shouldBlockPrices,
                locale: locale
            })
    });
const getBillingTermColumn = (context)=>_object_spread_props(_object_spread({}, baseColumn), {
        key: 'billing-term',
        name: context.loc('SimplePlanPricing_ColumnHeader_BillingTerm', 'Billing term'),
        minWidth: 136,
        isMultiline: true,
        onRender: ({ price })=>/*#__PURE__*/ _jsx(Text, {
                children: `${getBillingTermTranslated({
                    context,
                    term: price.unit,
                    useHyphen: true,
                    isSubscription: true
                })}`
            })
    });
export const subtotalColumnKey = 'subtotal';
const getSubtotalColumn = (context, billingCountry, locale)=>_object_spread_props(_object_spread({}, baseColumn), {
        key: subtotalColumnKey,
        name: context.loc('SimplePlanPricing_ColumnHeader_Subtotal', 'Subtotal'),
        minWidth: 136,
        isMultiline: true,
        onRender: ({ price, sku })=>/*#__PURE__*/ _jsx(SaasSubtotalCell, {
                sku: sku,
                price: price,
                billingCountry: billingCountry,
                locale: locale
            })
    });
const getNumberOfUsersColumn = (context, locale)=>_object_spread_props(_object_spread({}, baseColumn), {
        key: 'number-of-users',
        name: context.loc('SimplePlanPricing_ColumnHeader_NumberOfUsers', 'No. of users'),
        minWidth: 136,
        onRender: ({ sku: { minQuantity, maxQuantity } })=>{
            const minQuantityText = minQuantity.toLocaleString(locale);
            const maxQuantityText = Math.min(Constants.Checkout.MaxQuantity, maxQuantity).toLocaleString(locale);
            return /*#__PURE__*/ _jsx(Text, {
                children: `${minQuantityText} - ${maxQuantityText}`
            });
        }
    });
export const getColumns = ({ context, skus, billingCountry, locale, onGetInNowClicked, shouldBlockPrices, isOneTimePayment })=>{
    const planNameColumn = getPlanNameColumn(context, skus, onGetInNowClicked);
    const descriptionColumn = getDescriptionColumn(context);
    const priceAndPaymentOptionsColumn = getPriceAndPaymentOptionsColumn(context, billingCountry, shouldBlockPrices, locale);
    const billingTermColumn = getBillingTermColumn(context);
    const subtotalColumn = getSubtotalColumn(context, billingCountry, locale);
    const columns = isOneTimePayment ? [
        planNameColumn,
        descriptionColumn,
        priceAndPaymentOptionsColumn,
        subtotalColumn
    ] : [
        planNameColumn,
        descriptionColumn,
        priceAndPaymentOptionsColumn,
        billingTermColumn,
        subtotalColumn
    ];
    const isSeatBased = skus.some((sku)=>sku.minQuantity && sku.maxQuantity);
    if (isSeatBased) {
        const numberOfUsersColumn = getNumberOfUsersColumn(context, locale);
        const descriptionColumnIndex = 1;
        columns.splice(descriptionColumnIndex + 1, 0, numberOfUsersColumn);
    }
    return columns;
};
